import { calculateAge } from 'util/date/calculateAge'

export const isCidadaoVulneravelAlimentar = (cidadao): boolean => {
  const isCidadaoMaiorIdade = isCidadaoOlderThan18Years(cidadao, cidadao?.informacoesSocioEconomicasDW?.dataRegistro)
  const isCidadaoVulneravel =
    cidadao?.informacoesSocioEconomicasDW?.alimentosAcabaramSemDinheiro &&
    cidadao?.informacoesSocioEconomicasDW?.comeuPoucoPorFaltaDeDinheiro

  return isCidadaoVulneravel && isCidadaoMaiorIdade
}

export const isCidadaoOlderThan18Years = (cidadao, dataReferencia: LocalDate | Instant): boolean => {
  const idadeEmAnos: number = cidadao?.dataNascimento && calculateAge(cidadao.dataNascimento, dataReferencia).years
  return idadeEmAnos >= 18
}
